// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDetailThumbnail_wrapper__aF2EL","image":"ProductDetailThumbnail_image__Ufb58","safetyAlert":"ProductDetailThumbnail_safetyAlert__0KfAk"};